import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_EXCHANGE_RATES
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetViewExchangeRatesAction({
                    id: data.data.id,
                    to_currency: data.data.to_currency,
                    from_currency: data.data.from_currency,
                    value: data.data.value
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewExchangeRates as SetGetViewExchangeRates
}